import React from "react";

const StatsCard = ({ statsData }) => {
  // Extract event keys from statsData
  const eventKeys = Object.keys(statsData || {}).sort();
  
  // Calculate total clicks across all events
  const totalClicks = eventKeys.reduce((total, key) => {
    return total + (statsData[key]?.clicks || 0);
  }, 0);

  return (
    <div className="bg-[#191919] rounded-lg shadow-lg p-6 border border-[#ffffff18]">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-white">Event Tracking Statistics</h2>
        <div className="bg-[#333333] px-4 py-2 rounded-md">
          <span className="text-white font-medium">Total Clicks: {totalClicks}</span>
        </div>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full table-auto">
          <thead>
            <tr className="bg-[#2d2d2d] text-white">
              <th className="px-4 py-3 text-left">Event Name</th>
              <th className="px-4 py-3 text-left">Click Count</th>
            </tr>
          </thead>
          <tbody>
            {eventKeys.length > 0 ? (
              eventKeys.map((key) => (
                <tr key={key} className="border-b border-[#333333] hover:bg-[#222222]">
                  <td className="px-4 py-3 text-white text-left">{key}</td>
                  <td className="px-4 py-3 text-white text-left">{statsData[key]?.clicks || 0}</td>
                 
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="px-4 py-3 text-white text-center">
                  No events data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StatsCard;